import {
  ADD_BREAKDOWN_ITEM,
  PaymentTermActions,
  REMOVE_BREAKDOWN_ITEM,
  REMOVE_PAYMENT_TERM,
  RESET_PAYMENT_TERM,
} from "common/reducers/paymentTerm.actions";
import { PaymentTermRecord, paymentTermFromJSON } from "common/records/PaymentTerm";
import { Map, Record } from "immutable";
import { RootState, RootActions } from "common/reducers";
import { receive, reset } from "common/reducers/Utils";
import { RECEIVE_PAYMENT_TERM, RECEIVE_PAYMENT_TERMS } from "common/reducers/paymentTerm.actions";
import { estimatePaymentTermItemFromJSON } from "common/records/PaymentTermItem";

export const PaymentTermStateRecord = Record({
  byId: Map<number, PaymentTermRecord>(),
  lastSavedById: Map<number, PaymentTermRecord>(),
});

export const initialState = PaymentTermStateRecord();
export type PaymentTermState = typeof initialState;

const rootKey = "paymentTerms";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.getIn([rootKey])) {
    state = state.setIn([rootKey], initialState);
  }
  switch (action.type) {
    case RECEIVE_PAYMENT_TERM:
      const paymentTerm = paymentTermFromJSON({ ...action.payload });

      return receive(state, rootKey, paymentTerm) as RootState;

    case RECEIVE_PAYMENT_TERMS:
      action.payload.paymentTerms.forEach((paymentTerm) => {
        state = reducer(state, PaymentTermActions.receivePaymentTerm(paymentTerm));
      });

      return state;

    case REMOVE_PAYMENT_TERM:
      return state.removeIn([rootKey, "byId", action.payload]);

    case RESET_PAYMENT_TERM:
      return reset(state, rootKey, action.payload) as RootState;

    case ADD_BREAKDOWN_ITEM:
      return state.updateIn([rootKey, "byId", action.payload, "breakdown", "items"], (items) =>
        items.push(estimatePaymentTermItemFromJSON({})),
      );

    case REMOVE_BREAKDOWN_ITEM:
      return state.updateIn([rootKey, "byId", action.payload.paymentTermId, "breakdown", "items"], (items) =>
        items.delete(action.payload.itemIndex),
      );
    default:
      return state;
  }
};
